// TODO: Can be removed when ultimate_turbo_modal package has implemented a toggle to turn of close on submit
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  submitEnd(event) {
    event.stopPropagation();
  }
}
